import { render, staticRenderFns } from "./CommunicationRulesPage.vue?vue&type=template&id=273d16fa&scoped=true&"
import script from "./CommunicationRulesPage.vue?vue&type=script&lang=js&"
export * from "./CommunicationRulesPage.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationRulesPage.vue?vue&type=style&index=0&id=273d16fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d16fa",
  null
  
)

export default component.exports